<template>
  <div>
    <van-nav-bar
      title="撤单查询"
      left-text=""
      left-arrow
      @click-left="$router.push('/member/members')"

    />
    <van-list
      v-model="loadingWithdrawal"
      :finished="finishedWithdrawal"
      finished-text="没有更多了"
    >
      <div class="tableContent">
        <table class="stockTable" cellspacing="0" cellpadding="0" border="0">
          <tr class="tableheading">
            <th>名称代码</th>
            <th>委托方向</th>
            <th>委托价格</th>
            <th>委托数量</th>
            <th>未成交数量</th>
            <th>委托状态</th>
            <th>多头/空头</th>
            <th>委托时间</th>
          </tr>
          <tr
            class="stock_td"
            v-for="(item, index) in all_cancel"
            :key="index"
            style="font-size: 14px"
          >
            <td>
              <p>
                <span>{{ item.name }}</span
                ><br /><span>{{ item.short }}</span>
              </p>
            </td>
            <td>
              <p style="color: #D02E27">{{ item.type }}</p>
            </td>
            <td>
              <p>{{ item.deal }}</p>
            </td>
            <td>
              <p>{{ item.number }}</p>
            </td>
            <td>
              <p>{{ item.surplus }}</p>
            </td>
            <td>
              <p style="color: #D02E27">{{ item.status }}</p>
            </td>
            <td>
              <p>{{ item.direction }}</p>
            </td>
            <td>
              <p>{{ item.time }}</p>
            </td>
          </tr>
        </table>
        
      </div>
      <div style="margin-top: 25px; margin-bottom: 25px; color: #D02E27; font-weight: bold;text-align: center;">
          只显示最近12个月记录
        </div>
    </van-list>
  </div>
</template>

<script>
export default {
  name: "WithdrawalInquiry",
  data() {
    return {
      all_cancel: [],
      finished: false,
      loadingWithdrawal: false,
      finishedWithdrawal: false,
    };
  },

  methods: {
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    getAllCancel() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "all_cancel",
            token: window.sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (resData.code == 1) {
            that.all_cancel = resData.data;
            that.loadingWithdrawal = false;
            that.finishedWithdrawal = true;
          } else if (resData.code == 0 || resData.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        })
        .catch(() => {
          that.loadingWithdrawal = false;
          that.$toast.fail(that.$NoNetworkErrorMsg);
        });
    },
  },
  mounted: function () {
    let that = this;
    that.isLogin();
    that.getAllCancel();
  },
};
</script>

<style scoped>
.navstyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}

.tableheading {
  font-size: 14px;
  /* position: sticky;
  top: 46px; */
  padding-bottom: 10px;
  text-align: center;
  background: #ffffff;
  height: 45px;
  line-height: 45px;
}

.stockTable {
  /* margin-top: 10px; */
  text-align: left;
  width: 650px;
  padding: 0px 10px;
}

.stockTable th,
.stockTable td {
  width: 80px;
  text-align: center;
}

.stock_td p {
  margin: 5px 0px;
}

.tableContent {
  /* margin-top: 10px; */
  overflow-y: hidden;
  overflow-x: scroll;
  width: 100vw;
}
</style>



// WEBPACK FOOTER //
// src/components/WithdrawalInquiry.vue